import React from 'react';
import { Divider } from 'semantic-ui-react'

const AdminPagosCli21 = ({autorizacUA, styles, handleClickRegr, handleClickUpd, args, handleChange}) => {
  const a3555 = autorizacUA.findIndex( autorizac => autorizac === "3555" );

  // if(args.descrEmpresa){
  //   var descrEmpresa = document.getElementById("descrEmpresa");
  //   if(descrEmpresa){descrEmpresa.value = args.descrEmpresa}
  // }
  // if(args.numFactura){
  //   var numFactura = document.getElementById("numFactura");
  //   if(numFactura){numFactura.value = args.numFactura}
  // }
  // if(args.numOrdenCompra){
  //   var numOrdenCompra = document.getElementById("numOrdenCompra");
  //   if(numOrdenCompra){numOrdenCompra.value = args.numOrdenCompra}
  // }
  // if(args.ordenCompraCliente){
  //   var ordenCompraCliente = document.getElementById("ordenCompraCliente");
  //   if(ordenCompraCliente){ordenCompraCliente.value = args.ordenCompraCliente}
  // } 

  return (
    <div>
      {/* <button className="ui right labeled icon button fluid" type='submit' style={styles.titBuscar}>
        <i className="large search yellow icon"></i>
        Buscar
      </button>

      <div className="ui input fluid">
        <input id='descrEmpresa' autoComplete="off" name="descrEmpresa" type="text" placeholder="Cliente" style={styles.dropdown} onChange={handleChange}/>
      </div>
      <div className="ui input fluid">
        <input id='numFactura' autoComplete="off" name="numFactura" type="text" placeholder="No. de factura" style={styles.dropdown} onChange={handleChange}/>
      </div>
      <div className="ui input fluid">
        <input id='numOrdenCompra' autoComplete="off" name="numOrdenCompra" type="text" placeholder="No. de orden de compra LCM" style={styles.dropdown} onChange={handleChange}/>
      </div>
      <div className="ui input fluid">
        <input id='ordenCompraCliente' autoComplete="off" name="ordenCompraCliente" type="text" placeholder="No. de orden de compra del cliente" style={styles.dropdown} onChange={handleChange}/>
      </div>

      <p></p>
       */}
      <button className="ui right labeled icon button fluid" style={styles.titBuscar}>
        <i className="large sitemap yellow icon"></i>
        Opciones
      </button>

      {/* {a3555!==-1 &&
      <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickUpd}>
        <i className="large edit red icon"></i>
        Modificar
      </button>
      } */}
      <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickRegr}>
        <i className="large arrow left violet icon"></i>
        Regresar
      </button>
    </div>
  )
};

export default AdminPagosCli21
